import { gql } from '@apollo/client';


export const ADD_INVOICE_PRODUCT = gql`
  mutation AddProduct($input: ProductInputType!) {
    addInvoiceProduct(input: $input) {
      id
      name
      description
      price
      qty
      tax
      type
      billingPeriod
      image
    }
  }
`;

export const GET_ALL_INVOICE_PRODUCTS = gql`
  query getAllInvoiceProducts {
    getAllInvoiceProducts {
      id
      name
      description
      price
      tax
      qty
      type
      billingPeriod
      image
    }
  }
`;
